import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";
import { Grid, Container, Dialog, DialogContent, DialogActions, TextField } from "@material-ui/core/";
import InputMask from "react-input-mask";

import { format, parseISO } from "date-fns";

import Label from "../../components/Label";
import Button from "../../components/Button";
import Description from "../../components/Description";
import Terms from "../../components/Terms";

import EventApi from "../../services/event";

import { useLocation } from "react-router-dom";

import { Content, Row, LogoName, Header, Body, Align, TermsField } from "./styles";
import { config } from "../../config";
import eventLogo from "../../assets/images/fonacate_8a-congresso_logo.png";

const DirectConfirmation = (props) => {
    const [event, setEvent] = useState({});
    const [state, setState] = useState(true);
    const [rows, setRows] = useState([[]]);
    const [open, setOpen] = useState(false);
    const [person, setPerson] = useState({
        name: "",
        email: "",
        phone: "",
        certificate: 0,
        enable: true,
        company: "",
        role: "",
    });
    const [personPosition, setPersonPosition] = useState("");
    const [confirmed, setConfirmed] = useState(false);
    const [status, setStatus] = useState([{}]);
    const [rejected, setRejected] = useState(false);
    const [acceptedTerms, setAcceptedTerms] = useState(true);
    const [acceptedCenpComunication, setAcceptedCenpComunication] = useState(true);
    const [acceptedPartnersComunication, setAcceptedPartnersComunication] = useState(true);
    let location = useLocation();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function onChange(event) {
        const { value, name } = event.target;
        setPerson({ ...person, [name]: value });
    }

    const isValidForm = () => {
        let isValid = true;
        const errors = [];
        Object.entries(person).forEach(([key, value]) => {
            if (key === "name") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                }
            }
            if (key === "role") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira seu cargo");
                }
            }
        });
        if (errors && errors.length) errors.map((e) => toast.warn(e));
        return isValid;
    };

    const formatData = () => {
        const { id } = status.find((e) => {
            return e.name === "ACCEPTED";
        });
        return {
            ...person,
            status_id: id,
            email: person.name.trim().replace(" ", "") + "@temp.com",
            certificate: 0,
            enable: true,
            vip: false,
            solicitation_approved: true,
            is_guest: true,
            cpf: person.name.trim().replace(" ", ""),
            event_id: `${event.id}`,
            address: "#confirmed",
        };
    };

    const confirmPresence = () => {
        if (!isValidForm()) {
            toast.warn("Todos os campos devem ser preenchidos");
            return;
        }

        const formatedData = formatData();
        EventApi.createPerson({
            ...formatedData,
        })
            .then((createPersonResult) => {
                if (createPersonResult && createPersonResult.data) {
                    setConfirmed(true);
                    setRejected(false);
                    toast.success("Presença confirmada com sucesso!");
                } else if (createPersonResult?.response?.data?.message?.includes("Already used")) {
                    if (createPersonResult?.response?.data?.message?.includes("email"))
                        toast.error("O email inserido já foi cadastrado");
                    if (createPersonResult?.response?.data?.message?.includes("cpf"))
                        toast.error("O CPF inserido já foi cadastrado");
                } else toast.error("Ocorreu um erro.\nEntre em contato com a organização");
            })
            .catch((err) => {
                console.log(err);
                toast.error(`Ocorreu um erro. ${JSON.stringify(err)}\nEntre em contato com a organização`);
            });

        // EventApi.updatePerson(person.id, { ...formatedData })
        // .then(respUpdatePerson => {
        //     if (respUpdatePerson.data) {
        //         EventApi.sendConfirmationMail(
        //             person.name,
        //             person.email,
        //             `${config.QRCODE_HOST}/?size=200x200&data=${person.id}`
        //         ).catch(err => console.log(err));
        //         setConfirmed(true);
        //         setRejected(false);
        //         toast.success('Presença confirmada com sucesso');
        //     }
        // })
        // .catch(err => {
        //     console.log(err);
        //     toast.error('Ocorreu algum problema ao confirmar');
        // })

        // EventApi.updateStatusPerson(person.id, id)
        // .then(respConfirm => {
        //     console.log(respConfirm);
        //     setConfirmed(true);
        //     setRejected(false);
        //     toast.success('Presença confirmada com sucesso');
        // })
        // .catch(err => {
        //     console.log(err);
        //     toast.error('Ocorreu algum problema ao confirmar');
        // })
    };

    useEffect(() => {
        async function getData() {
            const respEvent = await EventApi.getEvent(props.match.params.event_id);
            if (!!respEvent.data) {
                setEvent(respEvent.data.data);
                EventApi.getPositionByEvent(props.match.params.event_id)
                    .then((respPos) => {
                        if (!!respPos.data) {
                            EventApi.getStatus()
                                .then((respStatus) => {
                                    if (!!respStatus.data) {
                                        setStatus(respStatus.data.data);
                                        const positions = Array(respEvent.data.data.lines)
                                            .fill()
                                            .map((u) =>
                                                Array(respEvent.data.data.columns)
                                                    .fill()
                                                    .map((u) => null)
                                            );
                                        respPos.data.data.forEach((item) => {
                                            const posit = {
                                                id: item.id,
                                                number: item.value,
                                                isSelected: false,
                                                isReserved: true,
                                            };
                                            positions[parseInt(item.line, 10)][parseInt(item.column, 10)] = posit;
                                        });
                                        setRows(positions);
                                    }
                                })
                                .catch(function (error) {
                                    toast.error(error);
                                });
                        } else {
                            toast.error("Posições não encontradas");
                            setState(false);
                        }
                    })
                    .catch(function (error) {
                        toast.error(error);
                    });
            } else {
                toast.error("Evento não encontrado");
                setState(false);
            }
        }

        getData();
    }, []);

    const success = (
        <>
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <Label size="big" color="white" align="center" font="Roboto" padding="50px 0 20px">
                    {confirmed || person?.status?.name === "ACCEPTED"
                        ? "Sua presença foi confirmada!"
                        : "Sua presença é aguardada"}
                </Label>

                {!confirmed && person?.status?.name !== "ACCEPTED" ? (
                    <div id="confirm-form">
                        <TextField
                            key="name"
                            name="name"
                            label="Digite seu nome completo"
                            required
                            fullWidth
                            value={person.name}
                            onChange={onChange}
                            inputProps={{
                                maxLength: 255,
                                style: {
                                    color: "white",
                                },
                            }}
                            InputLabelProps={{
                                style: {
                                    color: "rgb(255,255,255,0.54)",
                                },
                            }}
                        />
                        <TextField
                            key="role"
                            name="role"
                            label="Digite o seu cargo"
                            required
                            fullWidth
                            value={person.role}
                            onChange={onChange}
                            inputProps={{
                                maxLength: 255,
                                style: {
                                    color: "white",
                                },
                            }}
                            InputLabelProps={{
                                style: {
                                    color: "rgb(255,255,255,0.54)",
                                },
                            }}
                        />
                    </div>
                ) : null}

                {!confirmed && person?.status?.name !== "ACCEPTED" ? (
                    <Button
                        size="nano"
                        color="success"
                        format="solid"
                        width="100%"
                        margin="20px 0"
                        onClick={confirmPresence}
                    >
                        Confirmar Presença
                    </Button>
                ) : null}
                {/* {!rejected || person?.status?.name !== 'REJECTED'
                ?<Button
                    size='nano'
                    color='error'
                    format='solid'
                    width='100%'
                    margin='20px 0'
                    onClick={rejectInvite}
                >
                    Não Poderei Comparecer
                </Button>
            :null} */}

                {/* {!confirmed && person?.status?.name !== 'ACCEPTED' && <TermsField>
                <div>
                    <input type="checkbox" checked={acceptedTerms} onChange={(e) => {
                        setAcceptedTerms(e.target.checked)
                        if (!e.target.checked) toast.warn("É necessário aceitar os termos de uso de dados e imagens");
                    }} />
                    <p>Declaro que concordo com os <span onClick={() => handleClickOpen(true)}>Termos de Uso de dados e imagem</span></p>
                </div>
                <div>
                    <input type="checkbox" checked={acceptedCenpComunication} onChange={(e) => setAcceptedCenpComunication(e.target.checked)} />
                    <p>Declaro que aceito receber comunicações do Cenp</p>
                </div>
                <div>
                    <input type="checkbox" checked={acceptedPartnersComunication} onChange={(e) => setAcceptedPartnersComunication(e.target.checked)} />
                    <p>Declaro que aceito receber comunicações de parceiros do Cenp</p>
                </div>
            </TermsField>} */}

                <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                    <DialogContent>
                        <Terms />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            size="nano"
                            color="dark"
                            format="solid"
                            width="100%"
                            margin="20px 0"
                            onClick={handleClose}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </>
    );
    const eventNotFound = (
        <Label size="big" color="dark" align="center" font="Roboto" padding="10px 0 30px">
            Evento não encontrado
        </Label>
    );

    const defaultForm = (
        <>
            <Grid container justify="space-around" spacing={8}>
                <Grid item md={6}>
                    {/* <Label
                    size='big'
                    color='dark'
                    align='center'
                    font='Roboto'
                    padding='10px 0 30px'
                >{event.name}</Label> */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "20px",
                        }}
                    >
                        <img style={{ maxHeight: "300px", maxWidth: "300px" }} src={eventLogo} alt="Logo" />
                    </div>
                    <Description color="white" name="Data: " value="24 e 25 de Setembro" />
                    <Align>
                        <Label size="nano" color="white" align="left" weight="700" padding="5px 0">
                            Endereço:
                        </Label>
                        <Label size="nano" color="white" align="left" padding="5px 0">
                            {event.address}
                        </Label>
                    </Align>
                    <Label size="min" color="white" weight="100" font="Roboto" padding="50px 0">
                        {/* {event.description} */}O FONACATE é uma das principais entidades representativas do Serviço
                        Público no Brasil. E a 8ª Conferência Nacional das Carreiras de Estado contará com a presença de
                        servidores públicos, representantes do governo brasileiro, convidados internacionais e
                        acadêmicos. Sua presença será de fundamental importância para esse debate!
                    </Label>
                </Grid>
                <Grid className="border" item md={6}>
                    {success}
                </Grid>
            </Grid>
        </>
    );

    return (
        <>
            <Header>{event && <LogoName>{event.name}</LogoName>}</Header>
            <Body>
                <Container maxWidth="md">
                    <Content>
                        <Row>
                            <Container className="container" maxWidth="md">
                                {state ? defaultForm : eventNotFound}
                            </Container>
                        </Row>
                    </Content>
                </Container>
            </Body>
        </>
    );
};

export default DirectConfirmation;
